import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '../../../../styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    dialog: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 'inherit',
      maxHeight: '90vh',
      padding: '16px 32px 32px',
      overflow: 'hidden',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        maxHeight: 'none',
        padding: '8px 12px 16px',
        borderRadius: 0,
      },

      [theme.breakpoints.up('md')]: {
        width: '90vw',
        maxWidth: 1350,
        height: '90vh',
        borderRadius: 16,
      },
    },

    dialogTitle: {
      margin: 0,
      paddingLeft: 3,
      paddingRight: 0,
      paddingTop: 16,
      paddingBottom: 16,
      color: variables.richBlack,

      [theme.breakpoints.down('sm')]: {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },

    dialogTitleActions: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexShrink: 0,
    },

    closeBtn: {
      color: variables.richBlack,
    },

    root: {
      marginTop: 20,
      flexGrow: 1,
      minHeight: 0,
      flexWrap: 'nowrap',

      [theme.breakpoints.down('sm')]: {
        marginTop: 8,
      },
    },

    stickyHeader: {
      position: 'sticky',
      top: 0,
      backgroundColor: '#ffffff',
      zIndex: 1,
      flexShrink: 0,
    },

    headerDetails: {
      overflowX: 'auto',
      overflowY: 'hidden',

      [theme.breakpoints.down('sm')]: {
        paddingBottom: 8,
      },
    },

    tabsWrapper: {
      width: 'auto',

      [theme.breakpoints.down('sm')]: {
      },
    },

    tabs: {
      width: '100%',

      '& .MuiTabs-flexContainer': {
        width: '100%',
      },

      '& .MuiTabs-scroller': {
        width: '100%',
      },
    },

    tab: {
      minWidth: 0,
      maxWidth: 'none',
      flex: '1 1 0',

      [theme.breakpoints.down('sm')]: {
        minWidth: 'max-content',
        flex: '0 0 auto',
      },
    },

    tabScrollArea: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
    },

    cell: {
      verticalAlign: 'top',
    },

    margin: {
      display: 'grid',
      marginRight: 34,
    },

    title: {
      fontWeight: 400,
      fontSize: 14,
      padding: '10px 0',
      whiteSpace: 'nowrap',
    },

    emailTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 8,
      fontWeight: 400,
      fontSize: 14,
      padding: '8px 0',
      whiteSpace: 'nowrap',
    },

    copyButton: {
      padding: 2,

      '& svg': {
        fontSize: 14,
      },
    },

    value: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
      padding: '13px 0',
    },

    emailValue: {
      wordBreak: 'break-all',
    },

    taValue: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },

    topCell: {
      flex: 1,
      minWidth: 0,
      padding: '0 15px',

      [theme.breakpoints.down('sm')]: {
        flex: '0 0 auto',
        minWidth: 180,
        padding: '0 12px',
      },
    },

    showBy: {
      fontSize: 12,
      marginTop: 8,
      marginBottom: 5,
    },

    dialogAction: {
      marginTop: 16,
      justifyContent: 'flex-start',
    },
  }),
);
